import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './contexts/Theme.context';
import { BrowserRouter } from 'react-router-dom';
import MyAuth0Provider from './contexts/MyAuth0Provider';
import { CurrentUserProvider } from './contexts/CurrentUser.context';
import { CurrentPeriodProvider } from './contexts/CurrentPeriod.context';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MyAuth0Provider>
    <CurrentUserProvider>
      <CurrentPeriodProvider>
        <ThemeProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </CurrentPeriodProvider>
    </CurrentUserProvider>
  </MyAuth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
